<template>
  <div class="main main-tabbar">
    <TopCtrl />
    <ProductDetailHeader :product="product" ref="header" />
    <ProductDetailForm ref="form" :product="product" :sku="skuList" @onSkuChange="onSkuChange" />
    <ProductDetailBody :product="product" />
    <ProductDetailFooter
      :product="product"
      :type="type"
      ref="actions"
      @showPrizeModal="handleShowPrizeModal"
    />

    <!-- 兑换获取碎片和星星 -->
    <ModalMask v-if="showMask" />
    <transition name="bounce">
      <PrizeModal v-if="showPrize && active && !easyUser && enableLottery" @close="cloasPrizeModal" :prize="prize" />
    </transition>
    <Star ref="stars" @close="handleStarClose"/>

  </div>
</template>

<script>
import store from "../../api/store";

import ProductDetailHeader from "@/components/products/ProductDetailHeader";
import ProductDetailForm from "@/components/products/ProductDetailForm";
import ProductDetailBody from "@/components/products/ProductDetailBody";
import ProductDetailFooter from "@/components/products/ProductDetailFooter";
import ActionButton from "@/components/products/form/ActionButton";
import PrizeModal from "@/components/common/Modal/PrizeModal.vue";
import ModalMask from "@/components/common/Modal/ModalMask.vue";
import Star from "@/components/common/Modal/Star.vue";
import api from "../../api";
import $ from "jquery";

import VantButton from "vant/lib/button";

var wx = require("weixin-js-sdk");
var screenWidth = $(window).width();
var screenHeight = $(window).height();

export default {
  title: "商品详情页",

  bodyClass: "gray-bg",
  components: {
    ProductDetailHeader,
    ProductDetailForm,
    ProductDetailBody,
    ProductDetailFooter,
    ActionButton,
    PrizeModal,
    ModalMask,
    Star
  },
  data() {
    return {
      active: store.active,
      easyUser: store.loginedUser.easyUser,
      enableLottery:store.loginedUser.enableLottery,

      status: "",
      prize: 0,
      showPrize: false,
      showMask: false,
      showStart: false,
      currSku: null,
      product: {
        img: "",
        name: "",
        price: 0,
        sale: 0,
        content: "",
        steps: []
      },
      type: "",
      skuList: [
        // {
        //   skuId: 0,
        //   name: '0.5m',
        //   enable: true
        // }
      ]
    };
  },
  methods: {
    handleShowPrizeModal(prize) {
      this.prize = prize;
      this.showMask = true;
      this.showPrize = true;
    },
    cloasPrizeModal() {
      this.showPrize = false;
      setTimeout(() => {
        this.$refs.stars.startAnimation();
      }, 0.8 * 1000);
    },
    onChange(picker, value, index) {},
    showOrder() {
      this.$refs.form.showDialog();
    },
    onSkuChange(sku) {
      this.currSku = sku;
      this.$refs.actions.setSku(sku.skuId);
      this.$refs.header.setSku(sku);
    },
    handleStarClose(){
      this.showMask = false;
    }
  },
  created() {
    this.$showLoading("加载中...");
    var skuId = this.$route.query.skuId;
    api.product.getProduct(
      skuId,
      data => {
        var spu = data.spu;
        console.log(spu);
        spu.skuList.forEach(s => {
          if (s.skuId == skuId) {
            this.currSku = s;
          }
          if (s.enable) {
            this.skuList.push({
              skuId: s.skuId,
              name: s.name,
              title: s.title,
              price: s.price,
              image: s.image,
              soldCount: s.soldCount,
              steps: s.jingdongGoldBuyCounts || []
            });
          }
        });
        this.type = this.currSku.type;
        this.product.img = this.currSku.image;
        this.product.name = this.currSku.name;
        this.product.title = this.currSku.title;
        this.product.price = this.currSku.price;
        this.product.sale = this.currSku.soldCount;
        this.product.content = spu.detail;
        this.product.skuId = this.currSku.skuId;
        this.product.steps = this.currSku.jingdongGoldBuyCounts || [];

        setTimeout(() => {
          //不知道为啥，如果不采用异步处理会找不到form
          this.$refs.form.setCurrSku(skuId);
        }, 100);
        this.$hideLoading();

        //获取当前的Page，初始化分享参数
        wx.ready(() => {
          console.log("wx ready");
          // 微信分享的数据
          var shareData = {
            imgUrl: this.product.img, // 分享显示的缩略图地址
            link: location.href, // 分享地址
            desc: this.product.title, // 分享描述
            title: "好酷礼品商城", // 分享标题
            success: function() {
              // 分享成功可以做相应的数据处理
              //alert("分享成功"); }
            }
          };
          wx.onMenuShareTimeline(shareData);
          wx.onMenuShareAppMessage(shareData);
        });
      },
      r => {
        this.$alertDialog(r.msg, () => {
          this.$routerReplace(this, "/pages/homepage/Index");
        });
        this.$hideLoading();
      }
    );
  }
};
</script>

<style scoped lang="less">
@import "../../animation/animation.less";

.main {
  max-height: 100vh;
  // overflow: auto;
}

.hide-target {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/Detail.vue